import baseService from "./base.service";
import axios from "axios";

const resourceService = {
    init(path) {
        return {
            getById(id) {
                let url = `${path}/${id}`
                return baseService.request(axios.get(url))
            },
            get(url = path, paginate = true, params = null) {

                if (url) {
                    path = url
                }
                if (params == null) {
                    params = {}
                }
                params.paginate = paginate ? 1 : 0
                console.log(path)
                return baseService.request(axios.get(path, {
                    'params': params
                }))
            },
            store(data) {
                return baseService.request(axios.post(path, data))
            },
            delete(id) {
                let url = `${path}/${id}`
                return baseService.request(axios.delete(url))
            },
            update(id, data) {
                let url = `${path}/${id}`
                return baseService.request(axios.put(url, data))
            },


        }
    }
}

export default resourceService
